window.addEventListener('alpine:init', () => {
  var { removeSectionWrapper, getDefaultAlpineMorphLifecycleHooks } = Alpine.store('utilities');

  var defaultAlpineMorphLifecycleHooks = getDefaultAlpineMorphLifecycleHooks();

  function productCollection(data = {}) {
    return {
      ...data,

      isLoadingProductCollection: false,

      onIntersect() {
        this.isLoadingProductCollection = true;

        var url = new URL(`${location.origin}${this.collectionUrl}`);

        url.searchParams.set('section_id', this.sectionId);
        url.searchParams.set('q', `product_handle:${this.productHandle}`);

        if (Array.isArray(this.metafieldFilterValue)) {
          this.metafieldFilterValue.forEach((value) => {
            url.searchParams.append(`filter.p.m.${this.metafieldFilterMatch}`, value);
          });
        } else {
          url.searchParams.append(`filter.p.m.${this.metafieldFilterMatch}`, this.metafieldFilterValue);
        }

        fetch(url)
          .then((res) => {
            if (!res.ok) {
              throw new Error();
            }

            return res.text();
          })
          .then((res) => {
            var sectionHtml = removeSectionWrapper(res);

            Alpine.morph(this.$root, sectionHtml, defaultAlpineMorphLifecycleHooks);
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.isLoadingProductCollection = false;
          });
      }
    };
  };

  Alpine.data('productCollection', productCollection);
});
